<template>
    <div class="SortingGroup list">
        <div
                class="list__item"
                v-for="({title, rise}, index) of sortList"
                @click="setSortWithType(rise)"
                :key="index"
        >
            {{title}}
        </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
    name: "SortingGroup",
    props: {
        sortType: String,
        sortList: Array,
        close: Function,
    },
    methods: {
        setSortWithType(rise) {
            this.setSort({type: this.sortType, rise});
            this.close();
        },
        ...mapMutations(['setSort'])
    },
}
</script>

<style lang="scss">
.SortingGroup {
  white-space: nowrap;

  & + & {
    margin-top: 12px;
  }
}
</style>